import { createSlice } from "@reduxjs/toolkit";

export const kotTokenDisplaySlice = createSlice({
  name: "kotTokenDisplaySlice",
  initialState: {
    kotTokenData: null,
    isLoading: false,
    advertisementExpand: false,
    hideHeader: false,
    fontSize: "medium", // new
    fontColor: "white", // new
    backgroundColor: "#186734", // new
    prepareBG: "white", // new
    readyBG: "white", // new
    templatekot:"classic",
    prepareFontBG:"#994529",
    // Order type colors for modern theme
    dineinColor: "#994529",      // Brown for dine-in
    takeawayColor: "#1976d2",    // Blue for takeaway
    deliveryColor: "#388e3c",    // Green for delivery
    // Ready card order type colors
    readyDineinColor: "#186734",    // Green for ready dine-in
    readyTakeawayColor: "#1565c0", // Dark blue for ready takeaway
    readyDeliveryColor: "#2e7d32", // Dark green for ready delivery
    useOrderTypeColors: false, // Toggle for using separate order type colors
    // POS device filter for token display
    // New: support multiple selections
    selectedPosDeviceIds: [],
    // Back-compat single fields (may be unused by new UI)
    selectedPosDeviceId: null,
    selectedPosDeviceName: null,

    // Token Screen UI toggles
    showPreparingTimer: false,
    showHeaderDateTime: false,
    enableNewsScrollMedia: false,
    newsScrollItems: [],
    tickerAnimationType: "scroll",

    prepareColumnBgEnabled: false,
    readyColumnBgEnabled: false,
    prepareColumnBgOpacity: 30,
    readyColumnBgOpacity: 30,
    prepareColumnBgMediaIds: [],
    readyColumnBgMediaIds: [],
    columnBgIntervalMs: 6000,
  },

  reducers: {
    setKotTokenData: (state, action) => {
      state.kotTokenData = action.payload;
    },
    setAdvertisementExpand: (state, action) => {
      state.advertisementExpand = action.payload;
    },
    setHideHeader: (state, action) => {
      state.hideHeader = action.payload;
    },
    setFontSize: (state, action) => {
      state.fontSize = action.payload;
    },
    setTemplateKOT: (state, action) => {
      state.templatekot = action.payload;
    },
    setFontColor: (state, action) => {
      state.fontColor = action.payload;
    },
    setBackgroundColor: (state, action) => {
      state.backgroundColor = action.payload;
    },
    setPrepareBg: (state, action) => {
      state.prepareBG = action.payload;
    },
    setFontBgPreColor: (state, action) => {
      state.prepareFontBG = action.payload;
    },
    setDineinColor: (state, action) => {
      state.dineinColor = action.payload;
    },
    setTakeawayColor: (state, action) => {
      state.takeawayColor = action.payload;
    },
    setDeliveryColor: (state, action) => {
      state.deliveryColor = action.payload;
    },
    setReadyDineinColor: (state, action) => {
      state.readyDineinColor = action.payload;
    },
    setReadyTakeawayColor: (state, action) => {
      state.readyTakeawayColor = action.payload;
    },
    setReadyDeliveryColor: (state, action) => {
      state.readyDeliveryColor = action.payload;
    },
    setUseOrderTypeColors: (state, action) => {
      state.useOrderTypeColors = action.payload;
    },
    setReadyBgColor: (state, action) => {
      state.readyBG = action.payload;
    },
    setSelectedPosDevice(state, action) {
      const { deviceId, deviceName } = action.payload || {};
      state.selectedPosDeviceId = deviceId || null;
      state.selectedPosDeviceName = deviceName || null;
    },
    setSelectedPosDevices(state, action) {
      const ids = Array.isArray(action.payload) ? action.payload : [];
      state.selectedPosDeviceIds = ids.map((x) => (x ? String(x) : x));
    },

    setShowPreparingTimer(state, action) {
      state.showPreparingTimer = Boolean(action.payload);
    },
    setShowHeaderDateTime(state, action) {
      state.showHeaderDateTime = Boolean(action.payload);
    },
    setEnableNewsScrollMedia(state, action) {
      state.enableNewsScrollMedia = Boolean(action.payload);
    },
    setNewsScrollItems(state, action) {
      state.newsScrollItems = Array.isArray(action.payload) ? action.payload : [];
    },

    setTickerAnimationType(state, action) {
      state.tickerAnimationType = String(action.payload || "scroll");
    },

    setPrepareColumnBgEnabled(state, action) {
      state.prepareColumnBgEnabled = Boolean(action.payload);
    },
    setReadyColumnBgEnabled(state, action) {
      state.readyColumnBgEnabled = Boolean(action.payload);
    },
    setPrepareColumnBgOpacity(state, action) {
      const n = Number(action.payload);
      state.prepareColumnBgOpacity = Number.isFinite(n) ? n : state.prepareColumnBgOpacity;
    },
    setReadyColumnBgOpacity(state, action) {
      const n = Number(action.payload);
      state.readyColumnBgOpacity = Number.isFinite(n) ? n : state.readyColumnBgOpacity;
    },
    setPrepareColumnBgMediaIds(state, action) {
      state.prepareColumnBgMediaIds = Array.isArray(action.payload) ? action.payload : [];
    },
    setReadyColumnBgMediaIds(state, action) {
      state.readyColumnBgMediaIds = Array.isArray(action.payload) ? action.payload : [];
    },
    setColumnBgIntervalMs(state, action) {
      const n = Number(action.payload);
      state.columnBgIntervalMs = Number.isFinite(n) ? n : state.columnBgIntervalMs;
    },
  },
});

export const { setKotTokenData, setAdvertisementExpand, setHideHeader , setFontSize,
  setFontColor,
  setBackgroundColor,setPrepareBg,setReadyBgColor,  setTemplateKOT,setFontBgPreColor,
  setDineinColor, setTakeawayColor, setDeliveryColor,
  setReadyDineinColor, setReadyTakeawayColor, setReadyDeliveryColor,
  setUseOrderTypeColors,
  setSelectedPosDevice, setSelectedPosDevices,
  setShowPreparingTimer,
  setShowHeaderDateTime,
  setEnableNewsScrollMedia,
  setNewsScrollItems,
  setTickerAnimationType,
  setPrepareColumnBgEnabled,
  setReadyColumnBgEnabled,
  setPrepareColumnBgOpacity,
  setReadyColumnBgOpacity,
  setPrepareColumnBgMediaIds,
  setReadyColumnBgMediaIds,
  setColumnBgIntervalMs
   } =
  kotTokenDisplaySlice.actions;

export default kotTokenDisplaySlice.reducer;
